export const userSelectorQuery = 'user';

export const enum UserEndpoints {
  CreateUser = 'auth/register',
  MultipleUsers = 'user',
  SingleUser = 'user/{{0}}',
}
